"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _Block = _interopRequireDefault(require("@material-ui/icons/Block"));

var _core = require("@material-ui/core");

var _solarReact = require("@solar/solar-react");

var _DataForm = _interopRequireDefault(require("./DataForm"));

var _useProductData2 = _interopRequireDefault(require("./useProductData"));

var _helpers = require("./helpers");

var _ProductTypeSelector = _interopRequireDefault(require("./ProductTypeSelector"));

var _ProductDataPublicationDialog = _interopRequireDefault(require("./ProductDataPublicationDialog"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    preview: {
      flexGrow: 1
    },
    buttons: {
      // padding: 30,
      marginTop: 24,
      justifyContent: 'space-between'
    }
  };
});

var ProductData = function ProductData(_ref) {
  var product = _ref.product,
      labels = _ref.labels,
      openEditor = _ref.openEditor,
      onPublishDataChanges = _ref.onPublishDataChanges;
  var classes = useStyles();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      publicationDialogShown = _useState2[0],
      showPublicationDialog = _useState2[1];

  var _useState3 = (0, _react.useState)(product.types.length > 0 ? product.types[0].key : 'no-types'),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedType = _useState4[0],
      setSelectedType = _useState4[1];

  var _useProductData = (0, _useProductData2["default"])(product),
      formJSON = _useProductData.formJSON,
      formUIJSON = _useProductData.formUIJSON,
      formData = _useProductData.formData,
      changes = _useProductData.changes;

  var hasTypes = selectedType !== 'no-types';
  var activeType = hasTypes ? selectedType : 'general';
  var hasPublishedData = !!product.publishedFormSchema;
  var hasData = formJSON && formJSON[activeType] && formJSON[activeType] !== '' && formJSON[activeType] !== '{}' && (typeof formJSON[activeType] === 'string' || Object.keys(formJSON[activeType]).length > 0); // console.log({ hasTypes, activeType, hasData, formJSON });
  // if (hasData) {
  //   console.log(formJSON[activeType]);
  // }

  var title = product.title,
      _product$codes = product.codes,
      codes = _product$codes === void 0 ? [] : _product$codes,
      types = product.types,
      validity = product.validity;
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, hasData && /*#__PURE__*/_react["default"].createElement(_solarReact.ResponsiveSheet, null, hasTypes && /*#__PURE__*/_react["default"].createElement(_ProductTypeSelector["default"], {
    types: product.types,
    value: selectedType,
    onChange: function onChange(event) {
      setSelectedType(event.target.value);
    }
  }), hasData && /*#__PURE__*/_react["default"].createElement(_solarReact.Flex, {
    className: classes.buttons
  }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    variant: "contained",
    color: "primary",
    onClick: function onClick() {
      return openEditor(product._id);
    }
  }, "Open Editor"), /*#__PURE__*/_react["default"].createElement(_core.Button, {
    disabled: !changes,
    variant: "contained",
    color: "primary",
    onClick: function onClick() {
      if (hasPublishedData) {
        showPublicationDialog(true);
      } else {
        onPublishDataChanges({
          publishedFormSchema: (0, _helpers.parseAllProductJson)(product)
        });
      }
    }
  }, "Publish Changes"))), !hasData && /*#__PURE__*/_react["default"].createElement(_solarReact.EmptyState, {
    Icon: _Block["default"],
    label: labels.empty
  }), hasData && /*#__PURE__*/_react["default"].createElement(_DataForm["default"], {
    formJSON: formJSON[activeType],
    formUIJSON: formUIJSON[activeType],
    formData: formData[activeType],
    classes: {
      root: classes.preview
    }
  }), !hasData && /*#__PURE__*/_react["default"].createElement("center", null, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    variant: "contained",
    color: "primary",
    onClick: function onClick() {
      return openEditor(product._id);
    }
  }, "Open Editor")), /*#__PURE__*/_react["default"].createElement(_ProductDataPublicationDialog["default"], {
    open: publicationDialogShown,
    onReject: function onReject() {
      return showPublicationDialog(false);
    },
    onConfirm: function onConfirm(config) {
      showPublicationDialog(false);
      onPublishDataChanges({
        publishedFormSchema: (0, _helpers.parseAllProductJson)(product),
        config: config
      });
    },
    labels: {
      title: "You're updating a published data structure",
      body: 'Wanneer je reeds gepubliceerde data structuren hebt aangepast en opnieuw publiceert, heeft dit misschien impact op reeds aangemaakte fabrikaten.',
      confirm: 'voer wijzigingen door',
      cancel: 'annuleren'
    }
  }));
};

ProductData.propTypes = {
  className: _propTypes["default"].string,
  labels: _propTypes["default"].object.isRequired,
  product: _propTypes["default"].object.isRequired
};
ProductData.defaultProps = {
  className: ''
};
var _default = ProductData;
exports["default"] = _default;